import React, { useState } from 'react'
import styled from 'styled-components'
import ContextLink from '../../context-link'
import { TitleLink } from '../../../types/title-link'
import { desktop, mobile } from '../../utils/media-query'
import Arrow from '../../icons/arrow'
import DropdownMenu from '../dropdown-menu'
import { CSSTransition } from 'react-transition-group'
import { headerHeight } from '../../constants'
import { giphyAqua } from '../../../styles/colors'

export type NavLinkProps = {
    item: TitleLink
    hasDropdown?: boolean
}

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 20px;
    height: 100%;

    ${mobile.css`
        height: auto;
    `}
`

const ExtendedLink = styled(ContextLink)`
    text-decoration: none;
    color: white;
    font-weight: bold;
    border-bottom: none;
    font-family: 'PT Mono', monospace;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    ${desktop.css`
        &:hover::after {
            content: '';
            width: 100%;
            border-bottom: 5px solid ${giphyAqua};
            position: absolute;
            bottom: 0;
        }
    `}
`

const DropdownLink = styled.span`
    margin-right: 10px;
`

const DropdownContainer = styled.div`
    position: absolute;
    top: ${headerHeight}px;
    left: 0;
    width: 100%;

    &.fade.enter {
        opacity: 0.01;
    }

    &.fade.enter-active {
        opacity: 1;
        transition: opacity 200ms ease-in;
    }

    &.fade.exit {
        opacity: 1;
    }

    &.fade.exit-active {
        opacity: 0.01;
        transition: opacity 200ms ease-in;
    }
`

const NavLink = ({ item, hasDropdown }: NavLinkProps) => {
    const [showDropdown, setShowDropdown] = useState(false)

    const onMouseEnter = () => {
        hasDropdown && setShowDropdown(true)
    }

    const onMouseLeave = () => {
        hasDropdown && setShowDropdown(false)
    }

    return (
        <Container onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <ExtendedLink to={item.link}>
                <>
                    {hasDropdown && (
                        <DropdownLink>
                            <Arrow rotate={0} />
                        </DropdownLink>
                    )}
                    <span>{item.title}</span>
                </>
            </ExtendedLink>
            <CSSTransition in={showDropdown} className="fade" unmountOnExit timeout={200}>
                <DropdownContainer>
                    <DropdownMenu />
                </DropdownContainer>
            </CSSTransition>
        </Container>
    )
}

export default NavLink
